<template>
  <div v-if="resetObj" class="modal__body">
    <transition name="reset">
      <div v-if="!success">
        <BaseCaption :text="resetObj.resetTitle" tag="h3" />
        <BaseText :text="resetObj.resetDescription" />
        <form class="reset-password__form" @submit.prevent="reset">
          <BaseLabel forInput="emailReset" text="Email">
            <BaseField v-model="email" name="emailReset" type="email" :class="[{'modal__field_error': errors.email}]"/>
            <BaseErrorMessage v-if="errors.email">
              {{ errors.email[0] }}
            </BaseErrorMessage>
          </BaseLabel>
          <button class="btn  btn--default" type="submit">
            {{ resetObj.buttonLabel }}
          </button>
        </form>
      </div>
      <div v-if="success">
        <BaseCaption :text="resetObj.thankYouTitle" tag="h3" />
        <p class="text">{{ resetObj.thankYouDescription }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      email: '',
      errors: {},
      success: false
    }
  },
  computed: {
    ...mapGetters({
      resetObj: 'common/resetModal'
    })
  },
  methods: {
    async reset() {
      try {
        const response = await this.$store.dispatch(
          'auth/resetEmail',
          this.email
        )
        if (response.status === 200 && response.data.result === 'success') {
          this.success = true
        }
      } catch ({ response }) {
        this.errors = response.data.message
      }
    }
  },
  async beforeCreate() {
    const { data } = await this.$axios.get('/reset-password-page')

    this.$store.commit('common/SET_RESET', { ...data })
    this.$emit('ready')
  }
}
</script>



// WEBPACK FOOTER //
// components/modals/AppResetModal.vue